var _defs, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHindi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 361 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 8.11,
    y1: -138.04,
    x2: 38.09,
    y2: -144.5,
    gradientTransform: "translate(0 -114.47) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdb5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc52f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 32.67,
    y1: -141.79,
    x2: 19.76,
    y2: -152.3,
    gradientTransform: "translate(0 -114.47) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8ef2ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc52f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 43.54,
    y1: -141.79,
    x2: 56.46,
    y2: -152.3,
    gradientTransform: "translate(0 -114.47) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ce61ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc52f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.67,30c0-10.86,4.82-20.51,12.3-26.64,7.47,6.13,12.3,15.78,12.3,26.64s-4.82,20.51-12.3,26.64c-7.47-6.13-12.3-15.78-12.3-26.64Z",
    fill: "url(#linear-gradient)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.63,40.51c-5.55-9.19-6.17-19.97-2.61-29.2,9.83,1.13,19.09,6.69,24.65,15.88,5.55,9.19,6.17,19.97,2.61,29.2-9.83-1.13-19.09-6.69-24.65-15.88Z",
    fill: "url(#linear-gradient-2)",
    fillOpacity: 0.6,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.59,40.51c5.55-9.19,6.17-19.97,2.61-29.2-9.83,1.13-19.09,6.69-24.65,15.88-5.55,9.19-6.17,19.97-2.6,29.2,9.83-1.13,19.09-6.69,24.65-15.88Z",
    fill: "url(#linear-gradient-3)",
    fillOpacity: 0.6,
    fillRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M88.04,11.78h-4.08v3.41c.48,.3,1.01,.46,1.57,.46,.87,0,1.69-.36,2.47-1.09v2.21c-.6,.16-1.21,.25-1.83,.25-1.07,0-1.88-.22-2.42-.65-.21,.5-.59,.87-1.13,1.11l3.25,2.93-.83,.61-5.15-4.69c-.32-.28-.48-.58-.48-.89,0-.58,.33-.87,.99-.87,.32,0,.58,.03,.8,.09,.22,.06,.41,.17,.59,.32v-3.18h-3.51l-1.13-1.59h10.89v1.59Z",
    fill: "#3d1e1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.47,11.78l-1.11-1.59h11.75l1.06,1.59h-2.44v9.05l-2.13-1.14v-7.9h-7.13Zm7.13,6.37c-.69,.62-1.51,.93-2.44,.93s-1.89-.33-2.84-.99c-1.06-.73-1.59-1.54-1.59-2.43,0-.8,.42-1.48,1.27-2.05,.74-.49,1.54-.74,2.4-.74,1.28,0,2.35,.55,3.19,1.66v3.62Zm-.35-2.08v-.65c-.84-.48-1.62-.72-2.35-.72-.56,0-1.08,.17-1.55,.49-.47,.33-.71,.78-.71,1.34,0,.6,.34,.9,1.02,.9,.86,0,2.05-.45,3.58-1.36Z",
    fill: "#3d1e1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.46,11.78h-2.44v9.05l-2.14-1.14v-7.9h-1.66l-1.08-1.59h6.25l1.06,1.59Z",
    fill: "#3d1e1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.94,11.78v3.88h4.01v1.55h-4.01v.69c0,.45-.18,.67-.55,.67-.18,0-.35-.08-.51-.23l-2.21-2.03c-.09-.09-.15-.2-.18-.32,0-.22,.25-.33,.74-.33h.56v-3.88h-2.21l-1.06-1.59h12.92l1.06,1.59h-2.44v9.05l-2.13-1.14v-7.9h-4.01Z",
    fill: "#3d1e1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.84,10.17h-.83c-.14-.91-.44-1.63-.9-2.17-.53-.63-1.22-.95-2.06-.95-.55,0-1.08,.15-1.57,.46-.56,.35-.82,.79-.76,1.32h-1.38c-.25-.42-.37-.85-.37-1.27,0-.68,.35-1.21,1.04-1.59,.58-.31,1.23-.46,1.98-.46,1.42,0,2.59,.43,3.49,1.28,.91,.85,1.36,1.98,1.36,3.38Zm3.05,1.61h-2.44v9.05l-2.14-1.14v-7.9h-1.66l-1.08-1.59h6.25l1.06,1.59Z",
    fill: "#3d1e1c"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M92.95,32.26h-4.8v5.53c0,1.01-.15,1.78-.44,2.31-.3,.53-.89,.99-1.79,1.37l5.31,4.74-1.37,.99-8.37-7.59c-.5-.45-.74-.93-.74-1.44,0-.94,.54-1.41,1.63-1.41,1.03,0,1.76,.22,2.2,.66v-5.14h-5.69l-1.74-2.57h14.09l1.71,2.57Z",
    fill: "#3d1e1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.01,32.26h-3.94v14.65l-3.46-1.85v-12.8h-2.69l-1.74-2.57h10.12l1.71,2.57Z",
    fill: "#3d1e1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.64,32.26v6.29h6.49v2.51h-6.49v1.11c0,.72-.3,1.09-.89,1.09-.29,0-.56-.12-.83-.37l-3.57-3.29c-.15-.15-.25-.32-.29-.51,0-.36,.4-.54,1.2-.54h.91v-6.29h-3.57l-1.71-2.57h20.92l1.71,2.57h-3.94v14.65l-3.46-1.85v-12.8h-6.49Z",
    fill: "#3d1e1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.87,32.26v5.52c.78,.49,1.65,.74,2.6,.74,1.47,0,2.83-.59,4.09-1.77v3.57c-.9,.27-1.91,.4-3.03,.4-1.79,0-3.12-.35-4-1.06-.34,.8-.95,1.41-1.83,1.81l5.26,4.75-1.34,.99-8.34-7.59c-.51-.45-.77-.93-.77-1.44,0-.94,.53-1.41,1.6-1.41,.51,0,.95,.05,1.3,.14,.35,.1,.67,.27,.96,.51v-5.14h-5.69l-1.83-2.57h23.4l1.71,2.57h-3.94v14.66l-3.46-1.85v-12.8h-6.69Z",
    fill: "#3d1e1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.44,50.94v.29c0,.95-.51,1.76-1.52,2.43-.93,.55-2.01,.83-3.25,.83-3.22,0-6.62-1.55-10.2-4.66l1.34-.71c2.59,2.25,5.02,3.37,7.29,3.37,.48,0,.91-.05,1.3-.14,.39-.1,.82-.27,1.3-.51,1.05-.53,1.57-1.2,1.57-2,0-.32-.2-.49-.6-.49-.91,0-2.06,.51-3.43,1.54l-2.23-1.77c1.05-1.16,2.38-1.74,4-1.74,1.16,0,2.13,.3,2.91,.91,.48,.34,.85,.73,1.11,1.16,.27,.43,.4,.93,.4,1.5Z",
    fill: "#3d1e1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.53,32.26h-13.14v5.47c0,1.39-.57,2.41-1.71,3.08-.42,.23-.57,.45-.46,.66,.72,1.04,1.74,1.86,3.06,2.45,1.24,.53,2.53,.8,3.89,.8,2.51,0,5.17-.85,7.97-2.54v-.71c-1.1,.55-2.35,.83-3.74,.83-1.54,0-2.88-.34-4-1.02-1.28-.82-1.91-1.97-1.91-3.47,0-1.25,.57-2.27,1.71-3.05,1.01-.66,2.19-1,3.54-1,2.15,0,3.75,.73,4.8,2.2v9.12c-3.01,1.43-5.62,2.14-7.83,2.14-3.09,0-5.98-1.46-8.69-4.39-.84-.95-2.06-2.5-3.66-4.64l-.06-.23v-.17c0-.53,.41-.8,1.23-.8,.48,0,1.26,.14,2.34,.43v-5.14h-4.83l-1.77-2.57h23.26v2.57Zm-.4,5.9v-.37c-.84-.98-2.02-1.47-3.54-1.47-.78,0-1.57,.18-2.37,.55-.8,.37-1.2,.93-1.2,1.69,0,.95,.56,1.42,1.69,1.42,.69,0,1.57-.18,2.66-.55,1.09-.37,2.01-.79,2.77-1.26Z",
    fill: "#3d1e1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.36,32.26h-3.94v14.65l-3.46-1.85v-12.8h-2.69l-1.74-2.57h10.12l1.71,2.57Z",
    fill: "#3d1e1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.31,32.26h-4v4.4c0,.15-.09,.3-.26,.44-.17,.14-.37,.23-.6,.27h-4c-3.24,0-4.86,1.11-4.86,3.34,0,.91,.48,1.64,1.43,2.17,.8,.46,1.7,.69,2.69,.69,.36,0,.7-.03,1.01-.09,.31-.06,.64-.16,.99-.31l-.34-.54c-.25-.44-.37-.82-.37-1.14s.11-.6,.34-.83c.23-.23,.52-.34,.89-.34,.86,0,1.79,.3,2.8,.91,1.01,.61,1.52,1.32,1.52,2.14,0,.65-.49,1.2-1.48,1.66l2.82,4.02-1.34,1.09-3.04-4.68c-.89,.29-1.75,.43-2.59,.43-2.05,0-3.87-.71-5.46-2.14-1.59-1.43-2.39-3.16-2.39-5.2,0-1.09,.47-2,1.4-2.74,.88-.67,1.87-1,2.97-1h4.37v-2.54h-9.63l-1.83-2.57h17.12l1.86,2.57Z",
    fill: "#3d1e1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.82,32.26h-3.94v14.65l-3.46-1.85v-12.8h-2.69l-1.74-2.57h10.12l1.71,2.57Z",
    fill: "#3d1e1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.82,32.26v5.52c.78,.49,1.65,.74,2.6,.74,1.47,0,2.83-.59,4.09-1.77v3.57c-.9,.27-1.91,.4-3.03,.4-1.79,0-3.12-.35-4-1.06-.34,.8-.96,1.41-1.83,1.81l5.26,4.75-1.34,.99-8.34-7.59c-.51-.45-.77-.93-.77-1.44,0-.94,.53-1.41,1.6-1.41,.51,0,.95,.05,1.3,.14,.35,.1,.67,.27,.96,.51v-5.14h-5.69l-1.83-2.57h23.4l1.71,2.57h-3.94v14.66l-3.46-1.85v-12.8h-6.69Z",
    fill: "#3d1e1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.62,32.26l-1.74-2.57h23.17l1.71,2.57h-3.94v14.65l-3.46-1.85v-12.8h-15.74Zm15.74,5.12h-6.49c1.89,1.26,2.83,2.67,2.83,4.23,0,.8-.27,1.47-.8,2-.53,.5-1.21,.74-2.03,.74-1.94,0-3.85-.92-5.71-2.77-1.03-1.03-2.33-2.78-3.92-5.26l1.71-.37c1.66,3.41,3.55,5.12,5.69,5.12,1.37,0,2.06-.46,2.06-1.37,0-1.03-.97-2.29-2.91-3.77l-.06-.37c0-.5,.3-.74,.92-.74h8.71v2.57Z",
    fill: "#3d1e1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.68,29.66h-1.34c-.23-1.47-.71-2.64-1.46-3.51-.86-1.03-1.97-1.54-3.34-1.54-.9,0-1.74,.25-2.54,.74-.91,.57-1.32,1.29-1.23,2.14h-2.23c-.4-.69-.6-1.37-.6-2.06,0-1.1,.56-1.96,1.69-2.57,.93-.5,2-.74,3.2-.74,2.3,0,4.19,.69,5.66,2.07s2.2,3.21,2.2,5.47Zm4.94,2.6h-3.94v14.65l-3.46-1.85v-12.8h-2.69l-1.74-2.57h10.12l1.71,2.57Z",
    fill: "#3d1e1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.97,32.26v6.29h6.49v2.51h-6.49v1.11c0,.72-.29,1.09-.89,1.09-.29,0-.56-.12-.83-.37l-3.57-3.29c-.15-.15-.25-.32-.29-.51,0-.36,.4-.54,1.2-.54h.92v-6.29h-3.57l-1.71-2.57h20.92l1.71,2.57h-3.94v14.65l-3.46-1.85v-12.8h-6.49Z",
    fill: "#3d1e1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.49,32.26h-3.49v3.66c0,.19-.09,.35-.27,.48-.18,.13-.38,.22-.58,.26h-5.32c-2.1,0-3.14,.58-3.14,1.74l.08,.8c1.37-.57,2.78-.86,4.23-.86s2.78,.36,4,1.09c1.41,.86,2.12,1.96,2.12,3.31,0,1.71-1.24,2.87-3.71,3.46l-1.77-2.57c.65-.17,1.19-.52,1.63-1.06s.66-1.13,.66-1.8c0-.29-.04-.44-.11-.46-1.5,0-2.77,.29-3.8,.86-1.26,.69-1.89,1.74-1.89,3.17,0,.84,1.07,1.77,3.2,2.8,1.29,.59,2.71,1.1,4.26,1.54l-.43,1.14c-2.63-.51-4.86-1.21-6.69-2.08-2.93-1.37-4.4-2.97-4.4-4.8,0-1.08,.61-2.08,1.83-3-1.12-1.33-1.69-2.5-1.69-3.51,0-1.35,.98-2.03,2.94-2.03h5.31v-2.14h-9.66l-1.71-2.57h16.66l1.74,2.57Z",
    fill: "#3d1e1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.38,32.26h-3.94v14.65l-3.46-1.85v-12.8h-2.69l-1.74-2.57h10.12l1.71,2.57Z",
    fill: "#3d1e1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.23,32.26h-4.8v5.53c0,1.01-.15,1.78-.44,2.31-.3,.53-.89,.99-1.79,1.37l5.32,4.74-1.37,.99-8.37-7.59c-.5-.45-.74-.93-.74-1.44,0-.94,.54-1.41,1.63-1.41,1.03,0,1.76,.22,2.2,.66v-5.14h-5.69l-1.74-2.57h14.09l1.71,2.57Z",
    fill: "#3d1e1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.29,32.26h-3.94v14.65l-3.46-1.85v-12.8h-2.69l-1.74-2.57h10.12l1.71,2.57Z",
    fill: "#3d1e1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.95,32.26l-1.74-2.57h23.17l1.71,2.57h-3.94v14.65l-3.46-1.85v-12.8h-15.74Zm15.74,5.12h-6.49c1.89,1.26,2.83,2.67,2.83,4.23,0,.8-.27,1.47-.8,2-.53,.5-1.21,.74-2.03,.74-1.94,0-3.85-.92-5.71-2.77-1.03-1.03-2.33-2.78-3.92-5.26l1.71-.37c1.66,3.41,3.55,5.12,5.69,5.12,1.37,0,2.06-.46,2.06-1.37,0-1.03-.97-2.29-2.91-3.77l-.06-.37c0-.5,.3-.74,.92-.74h8.71v2.57Z",
    fill: "#3d1e1c"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHindi);
export default __webpack_public_path__ + "static/media/hindi.8021c7ca4f25b66d1ad98fd4b5415ca4.svg";
export { ForwardRef as ReactComponent };